export default {"src":"/_next/static/media/WhoWeAre_044A.e1fee61d.JPG","height":692,"width":1920};